import {
  type AddExpenseDTO,
  AddExpenseSchema,
  type FinalizeTripDTO,
  FinalizeTripSchema,
  TripViewSchema,
} from '@serviquim/contracts';
import { z } from 'zod';
import { authorizedRequest } from './auth';

const TripListSchema = z.array(TripViewSchema);

/** GET /trips — lista de viagens do viajante autenticado. */
export async function fetchTrips() {
  const data = await authorizedRequest<unknown>('/trips');
  return TripListSchema.parse(data);
}

/** GET /trips/:id — detalhe (teto, total gasto, sobra, gastos). */
export async function fetchTrip(id: string) {
  const data = await authorizedRequest<unknown>(`/trips/${id}`);
  return TripViewSchema.parse(data);
}

/**
 * POST /trips/:id/gastos — o backend deduplica pela `idempotencyKey` (RNF-14):
 * reenviar o mesmo gasto (mesma chave) não duplica (DoD 12).
 */
export async function submitExpense(tripId: string, dto: AddExpenseDTO) {
  const body = AddExpenseSchema.parse(dto);
  const data = await authorizedRequest<unknown>(`/trips/${tripId}/gastos`, {
    method: 'POST',
    body,
  });
  return TripViewSchema.parse(data);
}

export async function submeterTrip(id: string) {
  const data = await authorizedRequest<unknown>(`/trips/${id}/submeter`, { method: 'POST' });
  return TripViewSchema.parse(data);
}

/**
 * Finaliza a viagem. Para viagens de carro, envia o `odometroFim` (odômetro de
 * chegada) pra fechar o km rodado no backend (RF-VIA / FinalizeTripSchema).
 */
export async function finalizarTrip(id: string, dto?: FinalizeTripDTO) {
  const body = FinalizeTripSchema.parse(dto ?? {});
  const data = await authorizedRequest<unknown>(`/trips/${id}/finalizar`, { method: 'POST', body });
  return TripViewSchema.parse(data);
}

export async function prestarTrip(id: string) {
  const data = await authorizedRequest<unknown>(`/trips/${id}/prestar`, { method: 'POST' });
  return TripViewSchema.parse(data);
}
